import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import UserMyPageService from '@/service/userMyPage.service';
import {
  updateLocalStorageDsConnectomeLanguage,
  updateLocalStorageUserContentLanguage,
  updateLocalStorageUserLanguage,
} from '@/util/localStorage-util';
import TranslationService from '@/locale/translation.service';
import MultiSelect from '@/shared/multi-select/multi-select.vue';
import { CONTENT_LANGUAGES } from '@/constants';

const appStoreState = namespace('appStore');

@Component({
  computed: {},
  methods: {},
  components: { MultiSelect },
})
export default class MyPageSetting extends Vue {
  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @Inject('translationService')
  private translationService: () => TranslationService;

  @appStoreState.Mutation
  public setColorTheme!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsLoadingUpdateLanguage!: (payload: any) => void;

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  isLoading = false;
  currentTheme = localStorage.getItem('theme') || 'light';
  currentLanguage = this.localStorageUser?.langKey || 'en';
  contentLanguage = this.localStorageUser?.contentLanguages;
  contentLanguages = CONTENT_LANGUAGES;

  changeColorThemeAll() {
    this.isLoading = true;
    this.setIsLoadingUpdateLanguage(true);
    this.userMyPageService()
      .callApiChangeUserColorTheme(this.currentTheme)
      .then(() => {
        this.setColorTheme(this.currentTheme);
        localStorage.setItem('theme', this.currentTheme);
        this.isLoading = false;
        this.showResponseMessage(`${this.$t('toast.update.success')}`, `${this.$t('toast.title.success')}`, 'success', 5000);
        window.location.reload();
      })
      .catch(() => {
        this.setIsLoadingUpdateLanguage(false);
        this.showResponseMessage(`${this.$t('toast.update.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
      });
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }

  get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  roueToMyPage() {
    this.$router.push('/my-page');
  }

  @Watch('contentLanguage')
  onChangeContentLanguage() {
    this.changeLanguage();
  }

  changeLanguage() {
    this.isLoading = true;
    const newLanguage = this.currentLanguage;
    this.setIsLoadingUpdateLanguage(true);

    this.userMyPageService()
      .updateUserLanguage(this.currentLanguage, this.contentLanguage?.filter(Boolean)?.join(','))
      .then(res => {
        localStorage.setItem('currentLanguage', newLanguage);
        this.$store.commit('currentLanguage', newLanguage);
        this.translationService().refreshTranslation(newLanguage);
        this.$root.$emit('update-new-lang', newLanguage);
        updateLocalStorageDsConnectomeLanguage(newLanguage);
        updateLocalStorageUserLanguage(newLanguage);
        updateLocalStorageUserContentLanguage(this.contentLanguage);
        this.$store.commit('setUserIdentity', { ...this.userIdentity, langKey: newLanguage });

        this.isLoading = false;
        this.showResponseMessage(`${this.$t('toast.update.success')}`, `${this.$t('toast.title.success')}`, 'success', 5000);
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch(error => {
        this.isLoading = false;
        this.setIsLoadingUpdateLanguage(false);
        this.showResponseMessage(`${this.$t('toast.update.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
      });
  }
}
